import React from "react";
import { List, Button, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import styled from "styled-components";

const { Text } = Typography;

// ✅ Explicitly define the generic type as `List<string>`
const StyledList = styled<any>(List)`
  .ant-list-header {
    padding: 0.5em 0em 0em 0em;
  }
`;


interface StringListProps {
    items: string[];
    title: string;  // Ensure items is a string array
    onRemove?: (item: string) => void;
  }
  
const StringList: React.FC<StringListProps> = ({ items, title,  onRemove }) => {
  return (
    <>
    {items.length > 0 && (
    <StyledList
        header={<Text type="secondary"> {title} </Text>} 
        dataSource={items}
        renderItem={(item) => (
              <List.Item
                style={{padding: '0.2em 0em'}}
                actions={[
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onRemove?.(item)}
                  />,
                ]}
              >
                <Text>{item}</Text>
              </List.Item>
        )}
      />
    )}
    </>
  );
};

export default StringList